<app-private-header></app-private-header>
<router-outlet></router-outlet>
<app-private-footer></app-private-footer>